<template>
  <div id="p-index">
    index页面
  </div>
</template>
<script type="text/babel">
export default {
  name: 'Index',
  data() {
      return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss">
#p-index {

}
</style>
